import React from "react";
import { any, bool, node, number, string } from "prop-types";

const DashboardButton = ({ link, icon, description, fullWidth = false, maxWidth, children }) => {
  return (
    <div
      className="admin-dashboard-infos-action"
      style={{
        ...(fullWidth && { flex: 1 }),
        ...(fullWidth && !!maxWidth && { maxWidth: 320 })
    }}
    >
      <a href={link}>
        <div className="admin-dashboard-action-button-container">
          <div className="admin-dashboard-action-button-left">
            <div className="admin-dashboard-action-button-text">
              {children}
            </div>
            <div className="admin-dashboard-action-button-fancy">
              <div className="rounded-top" />
              <div className="rounded-bottom" />
            </div>
          </div>
          <div className="admin-dashboard-action-button-placeholder" />
          <div className="admin-dashboard-action-button-icon">
            {icon}
          </div>
        </div>
      </a>
      {!!description &&
        <div className="admin-dashboard-action-button-subtext">
          {description}
        </div>
      }
    </div>
  )
}

DashboardButton.propTypes = {
  link: string.isRequired,
  icon: node.isRequired,
  description: any,
  fullWidth: bool,
  maxWidth: number,
}

export default DashboardButton;